/**
 * @class ExampleComponent
 */

import React from 'react'

import styles from './styles.css'

export type Props = { text: string }

export default class ExampleComponent extends React.Component<Props> {
  render() {
    const {
      text
    } = this.props

    return (
      <div className={styles.test}>
        Example Component: {text}
      </div>
    )
  }
}

// export WfComponentProps  from "./lib/dform/components/WfComponent/WfComponentProps"
// export * from "./lib/dform/components/form/datetimepick/Ant-datetime"
export * from "./lib/index"